import { render } from "./Recommend.vue?vue&type=template&id=66949a90&scoped=true&ts=true"
import script from "./Recommend.vue?vue&type=script&lang=ts"
export * from "./Recommend.vue?vue&type=script&lang=ts"

import "./Recommend.vue?vue&type=style&index=0&id=66949a90&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66949a90"]])

export default __exports__